// extracted by mini-css-extract-plugin
export var container = "header-module--container--1-Wll";
export var campaignLogo = "header-module--campaign-logo--3SlRt";
export var logoBox = "header-module--logo-box--3z3DC";
export var sponsorLogo = "header-module--sponsor-logo--IxBHX";
export var ozLogo = "header-module--oz-logo--200DB";
export var kgwLogo = "header-module--kgw-logo--1G-Jl";
export var sell = "header-module--sell--gIHAC";